import classNames from 'classnames';

import { Dialog, DIALOG_ACTIONS_PORTAL_ID } from '@hcs/design-system';
import { useRerender } from '@hcs/hooks';

import { CERBERUS_STATS_CHART_LIMIT } from '../../constants';

import { MarketStateChartsForUser } from './MarketStateChartsForUser';
import { MARKET_STATS_FOR_USER_GEO_TYPE } from './marketStateChartsForUser.constants';

import styles from './MarketStateChartsForUser.module.css';

interface MarketStatsChartsForUserDialogProps {
  className?: string;
  active: boolean;
  onClose: VoidFunction;
  geoType:
    | typeof MARKET_STATS_FOR_USER_GEO_TYPE.ZIP
    | typeof MARKET_STATS_FOR_USER_GEO_TYPE.MSA;
}
const dataHcName = 'cerberus-status-chart-options-dialog';
export const MarketStateChartsForUserDialog = ({
  className,
  active: dialogActive,
  onClose,
  geoType,
}: MarketStatsChartsForUserDialogProps) => {
  // Rerender when dialog opens so we can get an accurate parent height for column calcs
  useRerender({
    deps: [dialogActive],
    shouldRerender: dialogActive,
  });

  return (
    <Dialog
      fullscreenOnPhone
      type="large"
      dataHcName={dataHcName}
      theme={{
        Dialog: classNames(styles.ChartOptionsDialog, className),
      }}
      active={dialogActive}
      title={'Market Activity Chart Data'}
      subtitle={
        <div>
          Use the controls below to prioritize or disable charts.{' '}
          <span
            data-hc-name={`${dataHcName}-chart-limit-message`}
            className={styles.LimitText}
          >{`${CERBERUS_STATS_CHART_LIMIT} chart max.`}</span>
        </div>
      }
      forceIsOverflowed
      onClose={onClose}
    >
      <MarketStateChartsForUser
        onSubmit={onClose}
        onCancel={onClose}
        geoType={geoType}
        actionsPortalIdRender={DIALOG_ACTIONS_PORTAL_ID}
      />
    </Dialog>
  );
};
